import { useEffect, useState } from 'react';

import Image from 'react-bootstrap/Image';

import Menu from '../../components/MenuProdutoSustentavel';

import header from '../../images/produto-sustentavel-header.png'

import constantes from '../../helpers/constanteHelper';

function Sobre() {
    const [width, setWidth] = useState(window.innerWidth);


    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    return (
        <>
            <div style={{ minHeight: '100vh', background: constantes.CORES.VERDE_PRODUTO_SUSTENTAVEL }} className='text-center d-flex flex-column align-items-center'>
                <Menu opcaoSelecionada={'sobre'} />
                <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center'>
                    <div style={{ height: resolucaoMobile ? '20px' : '80px' }}></div>

                    <Image style={{ height: '600px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
                    <h1 className={resolucaoMobile ? 'mb-5' : 'mt-5 mb-5'} style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>Certificação Produto Sustentável</h1>

                    <span className='mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center' }}>
                        O objetivo da certificação é reconhecer produtos que demonstram, por meio de critérios técnicos e evidências, seu compromisso com a sustentabilidade, contribuindo para uma produção animal mais responsável e alinhada às melhores práticas ambientais, sociais e de governança.<br /><br />
                        O selo Produto Sustentável da FairFood foi desenvolvido para valorizar tecnologias e soluções que promovem o uso eficiente dos recursos naturais, a redução dos impactos ambientais e a melhoria da sustentabilidade dos sistemas produtivos. Mais do que um reconhecimento, a certificação representa um compromisso com a inovação, a responsabilidade socioambiental e a construção de uma cadeia de produção animal preparada para os desafios do futuro.<br /><br />
                    </span>

                </div>
            </div>
        </>
    );
}

export default Sobre;
